function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9lZGl0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9lZGl0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBFZGl0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIkVkaXRcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIyLjE1NyAxMi42NTdsLTIuODMtMi44MyAxLjQxNS0xLjQxMiAyLjgyOSAyLjgyOC0xLjQxNCAxLjQxNHpNMTAuODI5IDIzLjk4NWwtMi44MjctLjAwMUw4IDIxLjE1N2w5LjkxMy05LjkxNSAyLjgyOCAyLjgyOS05LjkxMyA5LjkxNHptMTQuODYzLTEzLjQ1bC00LjI0My00LjI0MmExIDEgMCAwMC0xLjQxNCAwTDYuMjkzIDIwLjAzNWEuOTkyLjk5MiAwIDAwLS4yOTIuNzA3djQuMjQyYTEgMSAwIDAwMSAuOTk5bDQuMjQyLjAwMmMuMjY1IDAgLjUxOS0uMTA2LjcwNy0uMjkzTDI1LjY5MiAxMS45NWExIDEgMCAwMDAtMS40MTV6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuRWRpdC5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEVkaXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Edit(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Edit",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M22.157 12.657l-2.83-2.83 1.415-1.412 2.829 2.828-1.414 1.414zM10.829 23.985l-2.827-.001L8 21.157l9.913-9.915 2.828 2.829-9.913 9.914zm14.863-13.45l-4.243-4.242a1 1 0 00-1.414 0L6.293 20.035a.992.992 0 00-.292.707v4.242a1 1 0 001 .999l4.242.002c.265 0 .519-.106.707-.293L25.692 11.95a1 1 0 000-1.415z",
    fill: primaryColor
  }));
}

Edit.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Edit;